module.exports = __webpack_public_path__ + "img/Sign.04225acd.png";